var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM7.2,13.5,2.7,9,4,7.73,7.2,11,14,4.12,15.3,5.4Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }